export default __webpack_public_path__ + "static/hybridapp-f47f180f053372beba3af5d47acdcb2b.webp";